// Provider WS del comensal. Mientras haya sesión (token guest), abre UNA conexión
// al gateway dhk8-pos-realtime; el OrderTracker se suscribe a `ts:{tsid}:orders`
// para refrescar su pedido en vivo. Sin sesión (landing/check-in) NO conecta.
//
// IMPORTANTE: el provider se monta SIEMPRE (con `enabled=false` mientras no hay
// sesión). Antes, sin sesión devolvía los children "sueltos" y con sesión los
// envolvía en <RealtimeProvider>: al cambiar el tipo de nodo React REMONTABA toda
// la app justo después del check-in, y el CheckIn re-montado saltaba directo al
// menú (se perdían el pre-registro, "Pedido para llevar" y el código de mesa).
//
// Espejo de apps/pos PosRealtimeProvider, adaptado al token del comensal.

import { createElement, type ReactElement, type ReactNode } from 'react'
import { RealtimeProvider } from '@dockethub/realtime'
import { useSessionStore } from '../stores/session.store.js'
import { guestRealtimeWsUrl } from '../lib/realtime-url.js'

/** Árbol estable: mismo componente con o sin sesión; sólo cambia `enabled`. */
export function guestRealtimeTree(token: string, url: string, children: ReactNode): ReactElement {
  return createElement(RealtimeProvider, {
    url,
    token,
    enabled: token.length > 0 && url.length > 0,
    children,
  })
}

export function GuestRealtimeProvider({ children }: { children: ReactNode }) {
  const token = useSessionStore((s) => s.session?.token) ?? ''
  const url = guestRealtimeWsUrl()
  return guestRealtimeTree(token, url, children)
}
